import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { GetMarketingContactResponse } from "../../marketing.types";
import { requestGetMarketingContact } from "./getMarketingContact.request";

const useMarketingContact = (
  phone: string,
  options?: QueryOptions<GetMarketingContactResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["marketing", "contacts", "detail", phone],
    queryFn: async () => await requestGetMarketingContact(phone),
    onError: toastServerError,
    enabled: Boolean(phone),
    ...options
  });

  return { contact: data?.contact, events: data?.events ?? [], ...rest };
};

export default useMarketingContact;
